import { SKETCH_BORDER_PATH } from "./paths"

export const SKETCH_BORDER_SYMBOL_ID = "sketch-border"

// Mount once per document (root layout). Every SketchBorder cell references this
// single path via <use>, so the geometry lives in the DOM exactly one time.
// `non-scaling-stroke` keeps the optional low-DPR stroke boost (see SketchBorder) in CSS px,
// unaffected by the non-uniform scaling of the edge cells.
export function SketchSprite() {
  return (
    <svg aria-hidden width={0} height={0} className="absolute size-0 overflow-hidden" focusable="false">
      <defs>
        <path id={SKETCH_BORDER_SYMBOL_ID} d={SKETCH_BORDER_PATH} vectorEffect="non-scaling-stroke" />
      </defs>
    </svg>
  )
}
